export default __webpack_public_path__ + "static/media/ecosystem-logo.ae579547.png";